module.exports = __webpack_public_path__ + "static/media/notepad.f7d15ed0.ico";